import React, {Component} from 'react';
import '../../style.css';
import {
    Button,
    Card,
    Collapse,
    DatePicker,
    Form,
    Input,
    message,
    Modal,
    PageHeader,
    Select,
    Space, Steps,
    Table,
    Tag,
} from "antd";
import {fetchPost} from "../../static/util/fetch";
import {DeleteOutlined, EditOutlined, EnterOutlined, FolderOpenOutlined} from '@ant-design/icons';
import moment from 'moment';
const { Column } = Table;
const { Panel } = Collapse;
const { Step } = Steps;
const Option = Select.Option;
// let index1 = 0;
// let index2 = 0;
// let index3 = 0;
class CompanyList extends Component {
    constructor(props) {
        super(props);
        this.state={
            loading:false,
            data:[],//公司列表
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加公司弹窗状态
            delete_visible:false,//删除弹窗状态
            edit_field_visible:false,//修改技术领域弹窗状态
            pace_visible:false,//公司进度弹窗
            deleteId: 0,//待删除公司id
            editId: 0,
            paceId: 0,
            areaChoose:'',
            companyName:'',//公司名称
            registerTime:'',//公司注册时间
            declareTime:'',//
            field:'请选择技术领域',//
            member:'',//员工数量
            researcher:'',//科研人员数量
            income:'',//
            allIncome:'',//
            area:'',//用户地址
            registerArea:'',//公司注册地址
            //下面是新编辑的
            newCompanyName:'',//更新公司名称
            newRegisterTime:'',//更新公司注册时间
            newDeclareTime:'',//
            newField:'请选择技术领域',//更新技术领域
            newMember:'',//更新员工数量
            newResearcher:'',//科研人员数量
            newIncome:'',//更新收入
            newAllIncome:'',//更新总收入
            newArea:'',
            newRegisterArea:'',//更新公司注册地址
            //fieldOne:['一、电子信息','二、生物与新医药','三、航空航天','四、新材料','五、高技术服务','六、新能源与节能','七、资源与环境','八、先进制造与自动化'],
            fieldOne:[],
            fieldOneChoose:'请选择',
            fieldTwo:[],
            fieldTwoChoose:'请选择',
            fieldThree:[],
            fieldThreeChoose:'请选择',
            disabledStatus1:false,
            disabledStatus2:false,
            current:1,
            TechnicalFieldDescriptionStatus:false,
            IPNonReuseStatus:false,
            IPSummaryTableStatus:false,
            IPGeneralSituationStatus:false,
            IPFunctionStatus:false,
            PatentTransferSummaryStatus:false,
            OverallConditionStatus:false,
            ItemConditionStatus:false,
            BuildProjectSummaryStatus:false,
            BuildProjectResolutionStatus:false,
            ProjectReportStatus:false,
            ReceivingReportStatus:false,
            StaffSituationStatus:false,
            StaffRosterStatus:false,
            StaffStructureStatus:false,
            HighTechSpecificStatus:false,
            OpenInnovationStatus:false,
            OrganizationItemStatus:false,
            OrganizationOverAllStatus:false,
            PatentTransferManageStatus:false,
            PerformanceReviewStatus:false,
            RDAuxiliaryAccountStatus:false,
            RDCenterStatus:false,
            RDCenterFoundStatus:false,
            RDEquipmentStatus:false,
            RDInvestManageStatus:false,
            RDProjectManageStatus:false,
            ReserveFundStatus:false,
            TalentAcquisitionStatus:false,
            TechPersonRefreshStatus:false,
            TechPersonTrainStatus:false,
            addFieldOne:'',
            addFieldTwo:'',
            addFieldThree:'',
            areaList:[],
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.hideFieldModal = this.hideFieldModal.bind(this);
        this.editField = this.editField.bind(this);
        this.submitField = this.submitField.bind(this);
        this.addCompany = this.addCompany.bind(this);
        this.uploadCompany = this.uploadCompany.bind(this);
        this.deleteCompany = this.deleteCompany.bind(this);
        this.companyNameChange = this.companyNameChange.bind(this);
        this.registerTimeChange = this.registerTimeChange.bind(this);
        this.declareTimeChange = this.declareTimeChange.bind(this);
        this.fieldChangeOne = this.fieldChangeOne.bind(this);
        this.fieldChangeTwo = this.fieldChangeTwo.bind(this);
        this.fieldChangeThree = this.fieldChangeThree.bind(this);
        this.memberChange = this.memberChange.bind(this);
        this.researcherChange = this.researcherChange.bind(this);
        this.incomeChange = this.incomeChange.bind(this);
        this.allIncomeChange = this.allIncomeChange.bind(this);
        this.areaChange = this.areaChange.bind(this);
        this.registerAreaChange = this.registerAreaChange.bind(this);
        this.companyNameChangeNew = this.companyNameChangeNew.bind(this);
        this.registerTimeChangeNew = this.registerTimeChangeNew.bind(this);
        this.declareTimeChangeNew = this.declareTimeChangeNew.bind(this);
        this.fieldChangeNew = this.fieldChangeNew.bind(this);
        this.memberChangeNew = this.memberChangeNew.bind(this);
        this.researcherChangeNew = this.researcherChangeNew.bind(this);
        this.incomeChangeNew = this.incomeChangeNew.bind(this);
        this.allIncomeChangeNew = this.allIncomeChangeNew.bind(this);
        this.areaChangeNew = this.areaChangeNew.bind(this);
        this.registerAreaChangeNew = this.registerAreaChangeNew.bind(this);
    }
    componentDidMount() {
        //获取公司列表，不需要参数
        this.setState(()=>({
            loading:true
        }))
        console.log(global.constants.getCompanyList)
        fetchPost(global.constants.getCompanyList,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            data:res.data,
                            loading:false
                        }))
                    }
                    else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info(res.msg).then();
                    }
                }
            )
        fetchPost(global.constants.getOneLevel,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            fieldOne:res.data,
                        }))
                    }
                }
            )
        fetchPost(global.constants.getAllUserAreaList,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            areaList:res.data
                        }))
                    }
                }
            )
    }
    handleEnter = (e)=>{
        const value = e.companyName;
        let history = this.props.history;
        history.push('/navigation');
        localStorage.setItem("companyName",value)
        localStorage.setItem("companyId",e.id)
        localStorage.setItem("area",e.area)
    }
    handleDeleteList= (e) =>{
        //确定删除弹窗
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deleteCompany(){
        fetchPost(global.constants.deleteCompany,{id:this.state.deleteId})
            .then(
                res => {
                    console.log(res.code)
                    if(res.code === 200){
                        message.success('删除公司成功').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        fetchPost(global.constants.getCompanyList,{})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            data:res.data,
                                        }))
                                    }
                                    else{
                                        message.info(res.msg).then()
                                    }
                                }
                            )//更新后重新获取
                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                        this.setState(()=>({
                            data:[],
                        }))
                    }
                }
            )
    }
    hideModal(){
        this.setState({
            add_visible:false,
            edit_visible:false,
            delete_visible:false,
            pace_visible:false,
        });
    }
    hideFieldModal(){
        this.setState({
            edit_field_visible:false,
        });
    }
    handleAdd(){
        //打开添加公司弹窗
        this.setState(()=>({
            add_visible:true,
            companyName:'',
            registerTime:'',
            declareTime:'',
            fieldOneChoose:'请选择',
            fieldTwoChoose:'请选择',
            fieldThreeChoose:'请选择',
            fieldTwo:[],
            fieldThree:[],
            member:'',
            researcher:'',
            income:'',
            allIncome:'',
            area:'',
            registerArea:'',
        }))
    };
    checkCompany(){
        fetchPost(global.constants.checkCompanyName,{companyName:this.state.companyName})
            .then(
                res=>{
                    if(res.code === -1){
                        alert("该公司已存在")
                    }
                }
            )
    }
    addCompany(){
        if(this.state.companyName === ''||this.state.registerTime === ''||this.state.declareTime=== ''||
            this.state.fieldOneChoose === '请选择'||this.state.member === ''||this.state.researcher === ''||
            this.state.income === ''||this.state.allIncome === ''||this.state.area === ''
            ||this.state.registerArea === ''){
            message.info("请检查公司信息是否填写完整").then()
        }else{
            if(this.state.fieldTwoChoose === "请选择" || this.state.fieldTwoChoose === null){
                fetchPost(global.constants.addCompany, {
                    companyName:this.state.companyName,
                    registerTime: this.state.registerTime,
                    declareTime: this.state.declareTime,
                    field: this.state.fieldOneChoose +'-'+ this.state.fieldThreeChoose,
                    member:this.state.member,
                    researcher: this.state.researcher,
                    income: this.state.income,
                    allIncome: this.state.allIncome,
                    area: this.state.area,
                    registerArea: this.state.registerArea,
                    profile:this.state.companyName
                })
                    .then(
                        res => {
                            if (res.code === 200) {
                                message.success('添加成功！请完善左侧信息之后进入公司进行下一步操作！').then()
                                this.setState(() => ({
                                    add_visible: false
                                }))
                                fetchPost(global.constants.getCompanyList, {})
                                    .then(
                                        res => {
                                            if (res.code === 200) {
                                                this.setState(() => ({
                                                    data: res.data,
                                                }))
                                            } else {
                                                message.info(res.msg).then()
                                            }
                                        }
                                    )//更新后重新获取
                            } else {
                                message.error(res.msg).then()
                                // if (res.code === -1) {
                                //     console.log("添加公司失败，该公司已经存在！")
                                // }
                                // if (res.code === -2) {
                                //     console.log("添加公司失败（数据库错误）！")
                                // }
                                // if (res.code === -3) {
                                //     console.log("该用户已经绑定此公司！")
                                // }
                                // if (res.code === -4) {
                                //     console.log("添加用户管理公司失败（数据库错误）！")
                                // }
                                // if (res.code === null) {
                                //     console.log("返回值为空，添加失败")
                                // }
                            }
                        }
                    )
            }else {
                if(this.state.fieldThreeChoose === "请选择" || this.state.fieldThreeChoose === null){
                    fetchPost(global.constants.addCompany, {
                        companyName:this.state.companyName,
                        registerTime: this.state.registerTime,
                        declareTime: this.state.declareTime,
                        field: this.state.fieldOneChoose +'-'+ this.state.fieldTwoChoose,
                        member:this.state.member,
                        researcher: this.state.researcher,
                        income: this.state.income,
                        allIncome: this.state.allIncome,
                        area: this.state.area,
                        registerArea: this.state.registerArea,
                        profile:this.state.companyName
                    })
                        .then(
                            res => {
                                if (res.code === 200) {
                                    message.success('添加成功！请完善左侧信息之后进入公司进行下一步操作！').then()
                                    this.setState(() => ({
                                        add_visible: false
                                    }))
                                    fetchPost(global.constants.getCompanyList, {})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        data: res.data,
                                                    }))
                                                } else {
                                                    message.info(res.msg).then()
                                                }
                                            }
                                        )//更新后重新获取
                                } else {
                                    message.error(res.msg).then()
                                    // if (res.code === -1) {
                                    //     console.log("添加公司失败，该公司已经存在！")
                                    // }
                                    // if (res.code === -2) {
                                    //     console.log("添加公司失败（数据库错误）！")
                                    // }
                                    // if (res.code === -3) {
                                    //     console.log("该用户已经绑定此公司！")
                                    // }
                                    // if (res.code === -4) {
                                    //     console.log("添加用户管理公司失败（数据库错误）！")
                                    // }
                                    // if (res.code === null) {
                                    //     console.log("返回值为空，添加失败")
                                    // }
                                }
                            }
                        )
                }else{
                    fetchPost(global.constants.addCompany, {
                        companyName: this.state.companyName,
                        registerTime: this.state.registerTime,
                        declareTime: this.state.declareTime,
                        field: this.state.fieldOneChoose + '-' + this.state.fieldTwoChoose + '-' + this.state.fieldThreeChoose,
                        member: this.state.member,
                        researcher: this.state.researcher,
                        income: this.state.income,
                        allIncome: this.state.allIncome,
                        area: this.state.area,
                        registerArea: this.state.registerArea,
                        profile:this.state.companyName
                    })
                        .then(
                            res => {
                                if (res.code === 200) {
                                    message.success('添加成功！请完善左侧信息之后进入公司进行下一步操作！').then()
                                    this.setState(() => ({
                                        add_visible: false
                                    }))
                                    fetchPost(global.constants.getCompanyList, {})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        data: res.data,
                                                    }))
                                                } else {
                                                    message.info(res.msg).then()
                                                }
                                            }
                                        )//更新后重新获取
                                } else {
                                    message.error(res.msg).then()
                                    // if (res.code === -1) {
                                    //     console.log("添加公司失败，该公司已经存在！")
                                    // }
                                    // if (res.code === -2) {
                                    //     console.log("添加公司失败（数据库错误）！")
                                    // }
                                    // if (res.code === -3) {
                                    //     console.log("该用户已经绑定此公司！")
                                    // }
                                    // if (res.code === -4) {
                                    //     console.log("添加用户管理公司失败（数据库错误）！")
                                    // }
                                    // if (res.code === null) {
                                    //     console.log("返回值为空，添加失败")
                                    // }
                                }
                            }
                        )
                }

            }
        }

    }
    handleEditList= (e) =>{
        //打开编辑弹窗
        const value = e.id;
        this.setState(()=>({
            editId:value,
        }))
       //这里不能传this.state.editId，因为setState和下面的fetchPost是异步的
        fetchPost(global.constants.getCompany,{id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            newCompanyName: res.data.companyName,
                            newRegisterTime:res.data.registerTime,
                            newDeclareTime:res.data.declareTime,
                            newField:res.data.field,
                            newMember:res.data.member,
                            newResearcher:res.data.researcher,
                            newIncome:res.data.income,
                            newAllIncome:res.data.allIncome,
                            newArea:res.data.area,
                            newRegisterArea:res.data.registerArea,
                            edit_visible:true,
                        }))
                    }
                    // if(res.code === -1){
                    //     console.log("获取公司信息失败")
                    // }
                }
            )
    }
    uploadCompany(){
        let params = {
            id:this.state.editId,
            companyName: this.state.newCompanyName,
            registerTime: this.state.newRegisterTime,
            declareTime: this.state.newDeclareTime,
            field: this.state.newField,
            member: this.state.newMember,
            researcher: this.state.newResearcher,
            income: this.state.newIncome,
            allIncome: this.state.newAllIncome,
            area:this.state.newArea,
            registerArea: this.state.newRegisterArea,
        }
        fetchPost(global.constants.alterCompany, params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success(res.msg).then()
                        this.setState(()=>({
                            edit_visible:false
                        }))
                        fetchPost(global.constants.getCompanyList,{})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            data:res.data,
                                        }))
                                    }
                                    else{
                                        message.info(res.msg).then()
                                    }
                                }
                            )//更新后重新获取
                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                    }
                }
            )
    }
    handlePace(e){
        const value = e.id;
        const value1 = e.area;
        this.setState(()=>({
            pace_visible:true,
            areaChoose:value1,
            paceId:value,
            current:1,
            RegisterCertificatePapersStatus: false,
            TechnicalFieldDescriptionStatus:false,
            IPNonReuseStatus:false,
            IPSummaryTableStatus:false,
            IPGeneralSituationStatus:false,
            IPFunctionStatus:false,
            ResearchAuditReportStatus:false,
            ProductAuditReportStatus:false,
            FinancialAuditReportStatus:false,
            TaxFormStatus:false,
            IntermediaryProofStatus:false,
            PatentTransferSummaryStatus:false,
            OverallConditionStatus:false,
            ItemConditionStatus:false,
            BuildProjectSummaryStatus:false,
            BuildProjectResolutionStatus:false,
            StaffSituationStatus:false,
            StaffRosterStatus:false,
            StaffStructureStatus:false,
            StaffSecurityStatus:false,
            HighTechSpecificStatus:false,
            OpenInnovationStatus:false,
            OrganizationItemStatus:false,
            OrganizationOverAllStatus:false,
            PatentTransferManageStatus:false,
            PerformanceReviewStatus:false,
            RDAuxiliaryAccountStatus:false,
            RDCenterStatus:false,
            RDCenterFoundStatus:false,
            RDEquipmentStatus:false,
            RDInvestManageStatus:false,
            RDProjectManageStatus:false,
            ReserveFundStatus:false,
            TalentAcquisitionStatus:false,
            TechPersonRefreshStatus:false,
            TechPersonTrainStatus:false,
            RDEquipmentPhotoStatus:false,
            RDExpenseStatus:false,
            SchoolProtocolStatus:false,
            HonorQualificationStatus:false,
        }))
        fetchPost(global.constants.checkProcess, {id:value})
            .then(
                res=> {
                    if (res.code === 200) {
                        this.setState(() => ({
                            RegisterCertificatePapersStatus: res.data.registerCertificatePapersStatus,
                            TechnicalFieldDescriptionStatus:res.data.technicalFieldDescriptionStatus,
                            ResearchAuditReportStatus:res.data.researchAuditReportStatus,
                            ProductAuditReportStatus:res.data.productAuditReportStatus,
                            FinancialAuditReportStatus:res.data.financialAuditReportStatus,
                            TaxFormStatus:res.data.taxFormStatus,
                            IntermediaryProofStatus:res.data.intermediaryProofStatus,
                            PatentTransferSummaryStatus:res.data.patentTransferSummaryStatus,
                            OverallConditionStatus:res.data.overallConditionStatus,
                            ItemConditionStatus:res.data.itemConditionStatus,
                            BuildProjectSummaryStatus:res.data.buildProjectSummaryStatus,
                            BuildProjectResolutionStatus:res.data.buildProjectResolutionStatus,
                            StaffSituationStatus:res.data.staffSituationStatus,
                            StaffRosterStatus:res.data.staffRosterStatus,
                            StaffStructureStatus:res.data.staffStructureStatus,
                            StaffSecurityStatus:res.data.staffSecurityStatus,
                            HighTechSpecificStatus:res.data.highTechSpecificStatus,
                            IPNonReuseStatus:res.data.ipnonReuseStatus,
                            IPSummaryTableStatus:res.data.ipsummaryTableStatus,
                            IPGeneralSituationStatus:res.data.ipgeneralSituationStatus,
                            IPFunctionStatus:res.data.ipfunctionStatus,
                            OpenInnovationStatus:res.data.openInnovationStatus,
                            OrganizationItemStatus:res.data.organizationItemStatus,
                            OrganizationOverAllStatus:res.data.organizationOverAllStatus,
                            PatentTransferManageStatus:res.data.incentiveStatus,
                            PerformanceReviewStatus:res.data.performanceReviewStatus,
                            RDAuxiliaryAccountStatus:res.data.rdauxiliaryAccountStatus,
                            RDCenterStatus:res.data.rdcenterStatus,
                            RDCenterFoundStatus:res.data.rdcenterFoundStatus,
                            RDEquipmentStatus:res.data.rdequipmentStatus,
                            RDInvestManageStatus:res.data.rdinvestManageStatus,
                            RDProjectManageStatus:res.data.rdprojectManageStatus,
                            ReserveFundStatus:res.data.reserveFundStatus,
                            TalentAcquisitionStatus:res.data.talentAcquisitionStatus,
                            TechPersonRefreshStatus:res.data.techPersonRefreshStatus,
                            TechPersonTrainStatus:res.data.techPersonTrainStatus,
                            RDEquipmentPhotoStatus:res.data.rdequipmentPhotoStatus,
                            RDExpenseStatus:res.data.rdexpenseStatus,
                            SchoolProtocolStatus:res.data.schoolProtocolStatus,
                            HonorQualificationStatus:res.data.honorQualificationStatus,
                        }))
                        if (value1 === '江苏') {
                            if (this.state.RegisterCertificatePapersStatus === true) {
                                this.setState(() => ({
                                    current: 2
                                }))
                                if (this.state.IPNonReuseStatus === true && this.state.IPSummaryTableStatus === true) {
                                    this.setState(() => ({
                                        current: 3
                                    }))
                                    if(this.state.ResearchAuditReportStatus === true &&
                                        this.state.FinancialAuditReportStatus === true &&
                                        this.state.ProductAuditReportStatus === true &&
                                        this.state.TaxFormStatus === true &&
                                        this.state.IntermediaryProofStatus === true
                                    ){
                                        this.setState(() => ({
                                            current: 4
                                        }))
                                        if(this.state.PatentTransferSummaryStatus === true &&
                                            this.state.OverallConditionStatus === true &&
                                            this.state.ItemConditionStatus === true
                                        ){
                                            this.setState(() => ({
                                                current: 5
                                            }))
                                            if(this.state.BuildProjectSummaryStatus === true &&
                                                this.state.BuildProjectResolutionStatus === true
                                            ){
                                                this.setState(() => ({
                                                    current: 6
                                                }))
                                                if(this.state.StaffSituationStatus === true &&
                                                    this.state.StaffStructureStatus === true &&
                                                    this.state.StaffRosterStatus === true &&
                                                    this.state.StaffSecurityStatus === true
                                                ){
                                                    this.setState(() => ({
                                                        current: 7
                                                    }))
                                                    if(this.state.HighTechSpecificStatus === true){
                                                        this.setState(() => ({
                                                            current: 8
                                                        }))
                                                        if(this.state.OpenInnovationStatus === true &&
                                                            this.state.OrganizationItemStatus === true &&
                                                            this.state.OrganizationOverAllStatus === true &&
                                                            this.state.PatentTransferManageStatus === true &&
                                                            this.state.PerformanceReviewStatus === true &&
                                                            this.state.RDAuxiliaryAccountStatus === true &&
                                                            this.state.RDCenterFoundStatus === true &&
                                                            this.state.RDCenterStatus === true &&
                                                            this.state.RDEquipmentStatus === true &&
                                                            this.state.RDEquipmentPhotoStatus === true &&
                                                            this.state.RDExpenseStatus === true &&
                                                            this.state.RDInvestManageStatus === true &&
                                                            this.state.RDProjectManageStatus === true &&
                                                            this.state.ReserveFundStatus === true &&
                                                            //this.state.SchoolProtocolStatus === true &&
                                                            this.state.TalentAcquisitionStatus === true &&
                                                            this.state.TechPersonRefreshStatus === true &&
                                                            this.state.TechPersonTrainStatus === true
                                                        ){
                                                            this.setState(() => ({
                                                                current: 9
                                                            }))
                                                            if(this.state.HonorQualificationStatus === true) {
                                                                this.setState(() => ({
                                                                    current: 10
                                                                }))
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (value1 === '青岛') {
                            if (this.state.RegisterCertificatePapersStatus === true &&
                                this.state.TechnicalFieldDescriptionStatus === true
                            ) {
                                this.setState(() => ({
                                    current: 2
                                }))
                                if (this.state.IPNonReuseStatus === true &&
                                    this.state.IPSummaryTableStatus === true &&
                                    this.state.IPGeneralSituationStatus === true &&
                                    this.state.IPFunctionStatus === true
                                ) {
                                    this.setState(() => ({
                                        current: 3
                                    }))
                                    if(this.state.ResearchAuditReportStatus === true &&
                                        this.state.FinancialAuditReportStatus === true &&
                                        this.state.ProductAuditReportStatus === true &&
                                        this.state.TaxFormStatus === true &&
                                        this.state.IntermediaryProofStatus === true
                                    ){
                                        this.setState(() => ({
                                            current: 4
                                        }))
                                        if(this.state.PatentTransferSummaryStatus === true &&
                                            this.state.OverallConditionStatus === true &&
                                            this.state.ItemConditionStatus === true
                                        ){
                                            this.setState(() => ({
                                                current: 5
                                            }))
                                            if(this.state.BuildProjectSummaryStatus === true &&
                                                this.state.BuildProjectResolutionStatus === true
                                            ){
                                                this.setState(() => ({
                                                    current: 6
                                                }))
                                                if(
                                                    this.state.StaffStructureStatus === true &&
                                                    this.state.StaffRosterStatus === true &&
                                                    this.state.StaffSecurityStatus === true
                                                ){
                                                    this.setState(() => ({
                                                        current: 8
                                                    }))
                                                    if(this.state.OpenInnovationStatus === true &&
                                                        this.state.OrganizationItemStatus === true &&
                                                        this.state.OrganizationOverAllStatus === true &&
                                                        this.state.PatentTransferManageStatus === true &&
                                                        this.state.PerformanceReviewStatus === true &&
                                                        this.state.RDAuxiliaryAccountStatus === true &&
                                                        this.state.RDCenterFoundStatus === true &&
                                                        this.state.RDCenterStatus === true &&
                                                        this.state.RDEquipmentStatus === true &&
                                                        this.state.RDEquipmentPhotoStatus === true &&
                                                        this.state.RDExpenseStatus === true &&
                                                        this.state.RDInvestManageStatus === true &&
                                                        this.state.RDProjectManageStatus === true &&
                                                        this.state.ReserveFundStatus === true &&
                                                        //this.state.SchoolProtocolStatus === true &&
                                                        this.state.TalentAcquisitionStatus === true &&
                                                        this.state.TechPersonRefreshStatus === true &&
                                                        this.state.TechPersonTrainStatus === true
                                                    ){
                                                        this.setState(() => ({
                                                            current: 9
                                                        }))
                                                        if(this.state.HonorQualificationStatus === true) {
                                                            this.setState(() => ({
                                                                current: 10
                                                            }))
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (value1 === '山东其他地区') {
                            if (this.state.RegisterCertificatePapersStatus === true &&
                                this.state.TechnicalFieldDescriptionStatus === true) {
                                this.setState(() => ({
                                    current: 2
                                }))
                                if (this.state.IPNonReuseStatus === true && this.state.IPSummaryTableStatus === true) {
                                    this.setState(() => ({
                                        current: 3
                                    }))
                                    if(this.state.ResearchAuditReportStatus === true &&
                                        this.state.FinancialAuditReportStatus === true &&
                                        this.state.ProductAuditReportStatus === true &&
                                        this.state.TaxFormStatus === true &&
                                        this.state.IntermediaryProofStatus === true
                                    ){
                                        this.setState(() => ({
                                            current: 4
                                        }))
                                        if(this.state.PatentTransferSummaryStatus === true &&
                                            this.state.OverallConditionStatus === true &&
                                            this.state.ItemConditionStatus === true
                                        ){
                                            this.setState(() => ({
                                                current: 5
                                            }))
                                            if(this.state.BuildProjectSummaryStatus === true &&
                                                this.state.BuildProjectResolutionStatus === true
                                            ){
                                                this.setState(() => ({
                                                    current: 6
                                                }))
                                                if(
                                                    this.state.StaffRosterStatus === true &&
                                                    this.state.StaffSecurityStatus === true
                                                ){
                                                    this.setState(() => ({
                                                        current: 7
                                                    }))
                                                    if(this.state.HighTechSpecificStatus === true){
                                                        this.setState(() => ({
                                                            current: 8
                                                        }))
                                                        if(this.state.OpenInnovationStatus === true &&
                                                            this.state.OrganizationItemStatus === true &&
                                                            this.state.OrganizationOverAllStatus === true &&
                                                            this.state.PatentTransferManageStatus === true &&
                                                            this.state.PerformanceReviewStatus === true &&
                                                            this.state.RDAuxiliaryAccountStatus === true &&
                                                            this.state.RDCenterFoundStatus === true &&
                                                            this.state.RDCenterStatus === true &&
                                                            this.state.RDEquipmentStatus === true &&
                                                            this.state.RDEquipmentPhotoStatus === true &&
                                                            this.state.RDExpenseStatus === true &&
                                                            this.state.RDInvestManageStatus === true &&
                                                            this.state.RDProjectManageStatus === true &&
                                                            this.state.ReserveFundStatus === true &&
                                                            //this.state.SchoolProtocolStatus === true &&
                                                            this.state.TalentAcquisitionStatus === true &&
                                                            this.state.TechPersonRefreshStatus === true &&
                                                            this.state.TechPersonTrainStatus === true
                                                        ){
                                                            this.setState(() => ({
                                                                current: 9
                                                            }))
                                                            if(this.state.HonorQualificationStatus === true) {
                                                                this.setState(() => ({
                                                                    current: 10
                                                                }))
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
    }
    // onAddFieldOneChange(e){
    //     this.setState(()=>({
    //         addFieldOne:e.target.value
    //     }))
    // }
    // addItemOne(){
    //     const { fieldOne, addFieldOne } = this.state;
    //     this.setState({
    //         fieldOne: [...fieldOne, addFieldOne || `New item ${index1++}`],
    //         addFieldOne: '',
    //     });
    // }
    // onAddFieldTwoChange(e){
    //     this.setState(()=>({
    //         addFieldTwo:e.target.value
    //     }))
    // }
    // addItemTwo(){
    //     const { fieldTwo, addFieldTwo } = this.state;
    //     this.setState({
    //         fieldTwo: [...fieldTwo, addFieldTwo || `New item ${index2++}`],
    //         addFieldTwo: '',
    //     });
    // }
    // onAddFieldThreeChange(e){
    //     this.setState(()=>({
    //         addFieldThree:e.target.value
    //     }))
    // }
    // addItemThree(){
    //     const { fieldThree, addFieldThree } = this.state;
    //     this.setState({
    //         fieldThree: [...fieldThree, addFieldThree || `New item ${index3++}`],
    //         addFieldThree: '',
    //     });
    // }
    render(){
        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="公司列表"
                            subTitle={"默认显示该用户负责管理的所有公司，添加完公司后，请先添加左侧的三项后，再点击进入"}
                            extra={[
                                <Button
                                    type="primary"
                                    onClick={this.handleAdd}
                                >
                                    添加公司
                                </Button>
                            ]}
                        >
                        </PageHeader>
                    </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.data} loading={this.state.loading} onHeaderRow={()=>{return{className:"list-column-style"}}}>
                            <Column
                                align="center"
                                title={<p className="list-column-style">序号</p>}
                                width="80"
                                key='index'
                                render={
                                    (text,record,index)=>(`${index+1}`)} />
                            <Column
                                align="center"
                                title={<p className="list-column-style">公司名称</p>}
                                dataIndex="companyName"
                                key="companyName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">所属地区</p>}
                                dataIndex="area"
                                key="area" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EnterOutlined />}
                                            onClick={this.handleEnter.bind(this,record)}
                                        >进入</Button>
                                        <Button
                                             type="primary"
                                             icon={<EditOutlined />}
                                             onClick={this.handleEditList.bind(this,record)}
                                         >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDeleteList.bind(this,record)}
                                        >删除</Button>
                                        <Button
                                            type="primary"
                                            icon={<FolderOpenOutlined />}
                                            onClick={this.handlePace.bind(this,record)}
                                        >进度</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'修改公司信息'}
                    onOk={this.uploadCompany}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadCompany}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="公司名称" name="newCompanyName" >
                            <Input defaultValue={this.state.newCompanyName} onChange={(e) => this.companyNameChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="公司注册时间" name="newRegisterTime" >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                defaultValue={moment(this.state.newRegisterTime)} //默认值要求moment格式
                                format={'YYYY-MM-DD'}
                                onChange={this.registerTimeChangeNew}
                            />
                            </Space>
                        </Form.Item>
                        <Form.Item label="公司申报时间" name="newDeclareTime" >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    defaultValue={moment(this.state.newDeclareTime)}
                                    format={'YYYY-MM-DD'}
                                    onChange={this.declareTimeChangeNew}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="技术领域" name="newField" >
                            <div>{this.state.newField}</div>
                            <Button type="primary" onClick={this.editField}>修改</Button>
                        </Form.Item>
                        <Form.Item label="员工数量" name="newMember" >
                            <Input defaultValue={this.state.newMember} onChange={(e) => this.memberChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="科研人员数量" name="newResearcher" >
                            <Input defaultValue={this.state.newResearcher} onChange={(e) => this.researcherChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="近一年高品收入" name="newIncome" >
                            <Input style={{ width: 120}}
                                   defaultValue={this.state.newIncome}
                                   onChange={(e) => this.incomeChangeNew(e.target.value)}/>
                            &nbsp;&nbsp;万元
                        </Form.Item>
                        <Form.Item label="近一年总收入" name="newAllIncome" >
                            <Input style={{ width: 120}}
                                   defaultValue={this.state.newAllIncome}
                                   onChange={(e) => this.allIncomeChangeNew(e.target.value)}/>
                            &nbsp;&nbsp;万元
                        </Form.Item>
                        <Form.Item label="所属地区" name="newArea" >
                            <Select showSearch
                                    allowClear
                                    defaultValue={this.state.newArea}
                                    style={{ width: 300 }}
                                    placeholder="请选择地区"
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.areaChangeNew.bind(this)}
                            >
                                {this.state.areaList.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="公司注册地址"
                            name="newRegisterArea"
                        >
                            <Input
                                defaultValue={this.state.newRegisterArea}
                                onChange={(e) => this.registerAreaChangeNew(e.target.value)}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.edit_field_visible}
                    title={'修改技术领域'}
                    width={'70%'}
                    onOk={this.submitField}
                    onCancel={this.hideFieldModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideFieldModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.submitField}>
                            提交
                        </Button>,
                    ]}
                >
                    <div>
                        {/*<Dropdown overlay={field_menu_one} placement="bottomCenter" arrow trigger='click'>*/}
                        {/*    <Button type="primary" style={{marginRight:5}} onClick={this.showFieldOne.bind(this)}>{this.state.fieldOneChoose}</Button>*/}
                        {/*</Dropdown>*/}
                        {/*<Dropdown overlay={field_menu_two} placement="bottomCenter" arrow trigger='click' disabled={this.state.disabledStatus1}>*/}
                        {/*    <Button type="primary" style={{marginRight:5}}>{this.state.fieldTwoChoose}</Button>*/}
                        {/*</Dropdown>*/}
                        {/*<Dropdown overlay={field_menu_three} placement="bottomCenter" arrow trigger='click' disabled={this.state.disabledStatus2}>*/}
                        {/*    <Button type="primary" style={{marginRight:5}}>{this.state.fieldThreeChoose}</Button>*/}
                        {/*</Dropdown>*/}
                        <Select showSearch
                                style={{ width: 300 }}
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                defaultValue={this.state.fieldOneChoose}
                                searchPlaceholder="输入关键词"
                                onChange={this.fieldChangeOne.bind(this)}
                                // dropdownRender={menu => (
                                //     <div>
                                //         {menu}
                                //         <Divider style={{ margin: '4px 0' }} />
                                //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                //             <Input style={{ flex: 'auto' }} value={this.state.addFieldOne} onChange={this.onAddFieldOneChange.bind(this)} />
                                //             <Button
                                //                 type='link'
                                //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                //                 onClick={this.addItemOne.bind(this)}
                                //             >
                                //                 <PlusOutlined /> 添加
                                //             </Button>
                                //         </div>
                                //     </div>
                                // )}
                        >
                            {this.state.fieldOne.map(item => (
                                <Option key={item} value={item}>
                                    {item}
                                </Option>
                            ))}
                        </Select>
                        <Select showSearch
                                style={{ width: 300 }}
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                value={this.state.fieldTwoChoose}
                                onChange={this.fieldChangeTwo.bind(this)}
                                // dropdownRender={menu => (
                                //     <div>
                                //         {menu}
                                //         <Divider style={{ margin: '4px 0' }} />
                                //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                //             <Input style={{ flex: 'auto' }} value={this.state.addFieldTwo} onChange={this.onAddFieldTwoChange.bind(this)} />
                                //             <Button
                                //                 type='link'
                                //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                //                 onClick={this.addItemTwo.bind(this)}
                                //             >
                                //                 <PlusOutlined /> 添加
                                //             </Button>
                                //         </div>
                                //     </div>
                                // )}
                        >
                            {this.state.fieldTwo.map(item => (
                                <Option key={item} value={item} >
                                    {item}
                                </Option>
                            ))}
                        </Select>
                        <Select showSearch
                                style={{ width: 300 }}
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                value={this.state.fieldThreeChoose}
                                onChange={this.fieldChangeThree.bind(this)}
                                // dropdownRender={menu => (
                                //     <div>
                                //         {menu}
                                //         <Divider style={{ margin: '4px 0' }} />
                                //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                //             <Input style={{ flex: 'auto' }} value={this.state.addFieldThree} onChange={this.onAddFieldThreeChange.bind(this)} />
                                //             <Button
                                //                 type='link'
                                //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                //                 onClick={this.addItemThree.bind(this)}
                                //             >
                                //                 <PlusOutlined /> 添加
                                //             </Button>
                                //         </div>
                                //     </div>
                                // )}
                        >
                            {this.state.fieldThree.map(item => (
                                <Option key={item} value={item} >
                                    {item}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加公司'}
                    onOk={this.addCompany}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addCompany}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="公司名称" name="companyName" rules={[{ required: true, message: '请输入企业名称!' }]}>
                            <Input
                                onChange={(e) => this.companyNameChange(e.target.value)}
                                onBlur={this.checkCompany.bind(this)}
                            /></Form.Item>
                        <Form.Item label="公司注册时间" name="registerTime" rules={[{ required: true, message: '请输入注册时间!' }]}>
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.registerTimeChange}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="申报时间" name="declareTime" rules={[{ required: true, message: '请输入申报时间!' }]}>
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.declareTimeChange}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="技术领域" name="field" rules={[{ required: true, message: '请输入技术领域!' }]}>
                            <Select showSearch
                                    style={{ width: 300,bottom:10 }}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    defaultValue={this.state.fieldOneChoose}
                                    searchPlaceholder="输入关键词"
                                    onChange={this.fieldChangeOne.bind(this)}
                                    // dropdownRender={menu => (
                                    //     <div>
                                    //         {menu}
                                    //         <Divider style={{ margin: '4px 0' }} />
                                    //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                    //             <Input style={{ flex: 'auto' }} value={this.state.addFieldOne} onChange={this.onAddFieldOneChange.bind(this)} />
                                    //             <Button
                                    //                 type='link'
                                    //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                    //                 onClick={this.addItemOne.bind(this)}
                                    //             >
                                    //                 <PlusOutlined /> 添加
                                    //             </Button>
                                    //         </div>
                                    //     </div>
                                    // )}
                            >
                                {this.state.fieldOne.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 300,bottom:5 }}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    value={this.state.fieldTwoChoose}
                                    onChange={this.fieldChangeTwo.bind(this)}
                                    // dropdownRender={menu => (
                                    //     <div>
                                    //         {menu}
                                    //         <Divider style={{ margin: '4px 0' }} />
                                    //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                    //             <Input style={{ flex: 'auto' }} value={this.state.addFieldTwo} onChange={this.onAddFieldTwoChange.bind(this)} />
                                    //             <Button
                                    //                 type='link'
                                    //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                    //                 onClick={this.addItemTwo.bind(this)}
                                    //             >
                                    //                 <PlusOutlined /> 添加
                                    //             </Button>
                                    //         </div>
                                    //     </div>
                                    // )}
                            >
                                {this.state.fieldTwo.map(item => (
                                    <Option key={item} value={item} >
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 300 }}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    value={this.state.fieldThreeChoose}
                                    onChange={this.fieldChangeThree.bind(this)}
                                    // dropdownRender={menu => (
                                    //     <div>
                                    //         {menu}
                                    //         <Divider style={{ margin: '4px 0' }} />
                                    //         <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                    //             <Input style={{ flex: 'auto' }} value={this.state.addFieldThree} onChange={this.onAddFieldThreeChange.bind(this)} />
                                    //             <Button
                                    //                 type='link'
                                    //                 style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                    //                 onClick={this.addItemThree.bind(this)}
                                    //             >
                                    //                 <PlusOutlined /> 添加
                                    //             </Button>
                                    //         </div>
                                    //     </div>
                                    // )}
                            >
                                {this.state.fieldThree.map(item => (
                                    <Option key={item} value={item} >
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="员工数量" name="member" rules={[{ required: true, message: '请输入员工数量!' }]}>
                            <Input onChange={(e) => this.memberChange(e.target.value)}/></Form.Item>
                        <Form.Item label="科研人员数量" name="researcher" rules={[{ required: true, message: '请输入科研人员数量!' }]}>
                            <Input onChange={(e) => this.researcherChange(e.target.value)}/></Form.Item>
                        <Form.Item label="近一年高品收入" name="income" rules={[{ required: true, message: '请输入近一年高品收入!' }]}>
                            <Input style={{ width: 120}} onChange={(e) => this.incomeChange(e.target.value)}/>&nbsp;&nbsp;万元</Form.Item>
                        <Form.Item label="近一年总收入" name="allIncome" rules={[{ required: true, message: '请输入近一年总收入!' }]}>
                            <Input style={{ width: 120}} onChange={(e) => this.allIncomeChange(e.target.value)}/>&nbsp;&nbsp;万元</Form.Item>
                        <Form.Item label="所属地区" name="area" rules={[{ required: true, message: '请选择所属地区!' }]}>
                            <Select showSearch
                                    allowClear
                                    style={{ width: 300 }}
                                    placeholder="请选择地区"
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.areaChange.bind(this)}
                            >
                                {this.state.areaList.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="公司注册地址"
                            name="registerArea"
                            rules={[{ required: true, message: '请输入公司注册地!' }]}
                        >
                            <Input onChange={(e) => this.registerAreaChange(e.target.value)}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteCompany}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteCompany}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该公司吗？</div>
                </Modal>
                    <Modal
                        visible={this.state.pace_visible}
                        title={'该公司文件生成进度'}
                        width={"90%"}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.hideModal}>
                                确定
                            </Button>,
                        ]}
                    >
                        <Steps
                            current={this.state.current}
                            size="small"
                            labelPlacement="vertical"
                            responsive={true}>
                            <Step title="基本信息"  />
                            <Step title="资质证明"  />
                            <Step title="知识产权"  />
                            <Step title="审计报告"  />
                            <Step title="成果转化"  />
                            <Step title="立项" />
                            <Step title="人员" />
                            <Step title="高品" />
                            <Step title="组织管理"  />
                            <Step title="荣誉资质（选填）" />
                        </Steps>
                        <Collapse bordered={false}>
                            <Panel header="资质证明" key="1">
                                <Form>
                                    <Form.Item label="技术领域说明" name="TechnicalFieldDescriptionStatus">
                                        {
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                                        }
                                        {this.state.TechnicalFieldDescriptionStatus === true&&
                                            this.state.areaChoose !== '江苏'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.TechnicalFieldDescriptionStatus === false&&
                                            this.state.areaChoose !== '江苏'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}

                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="知识产权" key="2">
                                <Form>
                                    <Form.Item label="知识产权未重复使用说明" name="IPNonReuseStatus">
                                        {this.state.IPNonReuseStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="知识产权情况汇总表" name="IPSummaryTableStatus">
                                        {this.state.IPSummaryTableStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="知识产权概况" name="IPGeneralSituationStatus">
                                        {
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                                        }
                                        {
                                            this.state.areaChoose === '山东其他地区'&&
                                            <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                                        }
                                        {this.state.IPGeneralSituationStatus === true&&
                                            this.state.areaChoose !== '江苏'&&
                                            this.state.areaChoose !== '山东其他地区'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.IPGeneralSituationStatus === false&&
                                            this.state.areaChoose !== '江苏'&&
                                            this.state.areaChoose !== '山东其他地区'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item
                                        label="知识产权对主要产品（服务）在技术上发挥和信心作用介绍"
                                        name="IPFunctionStatus">
                                        {
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                                        }
                                        {
                                            this.state.areaChoose === '山东其他地区'&&
                                            <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                                        }
                                        {this.state.IPFunctionStatus === true&&
                                            this.state.areaChoose !== '江苏'&&
                                            this.state.areaChoose !== '山东其他地区'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.IPFunctionStatus === false&&
                                            this.state.areaChoose !== '江苏'&&
                                            this.state.areaChoose !== '山东其他地区'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="审计报告" key="3">
                                <Form>
                                    <Form.Item label="研发费用专项审计报告" name="ResearchAuditReportStatus">
                                        {this.state.ResearchAuditReportStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="高品专项审计报告" name="ProductAuditReportStatus">
                                        {this.state.ProductAuditReportStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="财务审计报告" name="FinancialAuditReportStatus">
                                        {this.state.FinancialAuditReportStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="纳税申报表" name="TaxFormStatus">
                                        {this.state.TaxFormStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="中介证明" name="IntermediaryProofStatus">
                                        {this.state.IntermediaryProofStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="成果转化" key="4">
                                <Form>
                                    <Form.Item label="近三年成果转化汇总表" name="PatentTransferSummaryStatus">
                                        {this.state.PatentTransferSummaryStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="科技成果总体情况说明" name="OverallConditionStatus">
                                        {this.state.OverallConditionStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="科技成果逐项说明" name="ItemConditionStatus">
                                        {this.state.ItemConditionStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="立项" key="5">
                                <Form>
                                    <Form.Item label="项目立项汇总表" name="BuildProjectSummaryStatus">
                                        {this.state.BuildProjectSummaryStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label={"立项材料"}
                                               name="BuildProjectResolutionStatus">
                                        {this.state.BuildProjectResolutionStatus === true?
                                            <Tag color="green" className="Tag_style" >已上传</Tag>:
                                            <Tag color="red" className="Tag_style">未上传</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="人员" key="6">
                                <Form>
                                    <Form.Item label="人员情况表" name="StaffSituationStatus">
                                        {
                                            this.state.areaChoose === '青岛'&&
                                            <Tag color="gray" className="Tag_style" >青岛无此文件</Tag>
                                        }
                                        {
                                            this.state.areaChoose === '山东其他地区'&&
                                            <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                                        }
                                        {this.state.StaffSituationStatus === true&&
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.StaffSituationStatus === false&&
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="人员花名册" name="StaffRosterStatus">
                                        {this.state.StaffRosterStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="人员结构表" name="StaffStructureStatus">
                                        {this.state.StaffStructureStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="高品" key="7">
                                <Form>
                                    <Form.Item label="高品技术和技术指标具体说明"
                                               name="HighTechSpecificStatus">
                                        {
                                            this.state.areaChoose === '青岛'&&
                                            <Tag color="gray" className="Tag_style" >青岛无此文件</Tag>
                                        }
                                        {this.state.HighTechSpecificStatus === true&&
                                            this.state.areaChoose === '山东其他地区'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.HighTechSpecificStatus === false&&
                                            this.state.areaChoose === '山东其他地区'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                        {this.state.HighTechSpecificStatus === true&&
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                                        {this.state.HighTechSpecificStatus === false&&
                                            this.state.areaChoose === '江苏'&&
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="组织管理" key="8">
                                <Form>
                                    <Form.Item label="研究开发组织管理水平总体情况说明"
                                               name="OrganizationOverAllStatus">
                                        {this.state.OrganizationOverAllStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研究开发组织管理水平指标逐项说明"
                                               name="OrganizationItemStatus">
                                        {this.state.OrganizationItemStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发项目管理制度"
                                               name="RDProjectManageStatus">
                                        {this.state.RDProjectManageStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发投入核算管理制度"
                                               name="RDInvestManageStatus">
                                        {this.state.RDInvestManageStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发辅助账管理办法"
                                               name="RDAuxiliaryAccountStatus">
                                        {this.state.RDAuxiliaryAccountStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="企业研发准备金制度"
                                               name="ReserveFundStatus">
                                        {this.state.ReserveFundStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="关于成立研发中心的通知"
                                               name="RDCenterFoundStatus">
                                        {this.state.RDCenterFoundStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发中心建设情况说明"
                                               name="RDCenterStatus">
                                        {this.state.RDCenterStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发设备明细表"
                                               name="RDEquipmentStatus">
                                        {this.state.RDEquipmentStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="科技成果转化的组织实施与激励奖励制度"
                                               name="PatentTransferManageStatus">
                                        {this.state.PatentTransferManageStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="开放式创新创业平台制度"
                                               name="OpenInnovationStatus">
                                        {this.state.OpenInnovationStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="科技人员培训管理制度"
                                               name="TechPersonTrainStatus">
                                        {this.state.TechPersonTrainStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="科技人员培养进修制度"
                                               name="TechPersonRefreshStatus">
                                        {this.state.TechPersonRefreshStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="人才引进制度"
                                               name="TalentAcquisitionStatus">
                                        {this.state.TalentAcquisitionStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                    <Form.Item label="研发人员绩效考核制度"
                                               name="PerformanceReviewStatus">
                                        {this.state.PerformanceReviewStatus === true?
                                            <Tag color="green" className="Tag_style" >已生成</Tag>:
                                            <Tag color="red" className="Tag_style">未生成</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                            <Panel header="荣誉资质（选填）" key="9">
                                <Form>
                                    <Form.Item label="荣誉资质数据（选填）"
                                               name="HonorQualificationStatus">
                                        {this.state.HonorQualificationStatus === true?
                                            <Tag color="green" className="Tag_style" >已上传</Tag>:
                                            <Tag color="red" className="Tag_style">未上传</Tag>}
                                    </Form.Item>
                                </Form>
                            </Panel>
                        </Collapse>


                    </Modal>
            </div>
            </div>
        )
    }
    companyNameChange(e){
        this.setState({
            companyName:e
        })
    }
    registerTimeChange=(value,dateString) =>{
        this.setState({
            registerTime:dateString
        })
    }
    declareTimeChange=(value,dateString)=>{
        this.setState({
            declareTime:dateString
        })
    }
    areaChange(e){
        this.setState({
            area:e
        })
    }
    // showFieldOne(){
    //     this.setState(()=>({
    //         fieldOne:['一、电子信息','二、生物与新医药','三、航空航天','四、新材料','五、高技术服务','六、新能源与节能','七、资源与环境','八、先进制造与自动化']
    //     }))
    // }
    fieldChangeOne(e){
        this.setState({
            fieldOneChoose:e
        })
        fetchPost(global.constants.getTwoLevel,{oneLevel:e})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            fieldTwoChoose:'请选择',
                            fieldThreeChoose:'请选择',
                            disabledStatus1:false,
                            disabledStatus2:false,
                            fieldTwo:res.data,
                            fieldThree:[],
                        }))
                    }
                }
            )
        // if(e == '一、电子信息'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo:['（一）软件','（二）微电子技术','（三）计算机及网络技术','（四）通信技术','（五）广播电视技术','（六）新型电子元器件','（七）信息安全技术','（八）智能交通技术'],
        //         fieldThree:[],
        //     }))
        // }
        // if(e == '二、生物与新医药'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo: ['（一）医药生物技术','（二）中药、天然药物','（三）化学药','（四）新剂型及制剂技术','（五）医疗仪器技术、设备与医学专用软件','（六）轻工和化工生物技术','（七）现代农业技术'],
        //         fieldThree:[],
        //     }))
        // }
        // if(e == '三、航空航天'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:true,
        //         disabledStatus2:false,
        //         fieldTwo:[],
        //         fieldThree:['1、民用飞机技术','2、空中管制系统','3、新一代民用航空运行保障系统','4、卫星通信应用系统','5、卫星导航应用服务系统'],
        //     }))
        // }
        // if(e == '四、新材料'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo:['（一)金属材料','（二）无机非金属材料','（三）高分子材料','（四）生物医用材料','（五）精细化学品'],
        //         fieldThree:[],
        //     }))
        // }
        // if(e == '五、高技术服务'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:true,
        //         disabledStatus2:false,
        //         fieldTwo:[],
        //         fieldThree:['1、共性技术','2、现代物流','3、集成电路','4、业务流程外包（BPO）','5、文化创意产业支撑技术','6、公共服务','7、技术咨询服务','8、精密复杂模具设计','9、生物医药技术','10、工业设计'],
        //     }))
        // }
        // if(e == '六、新能源与节能'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo:['（一）可再生清洁能源技术','（二）核能及氢能','（三）新型高效能量转换与储存技术','（四）高效节能技术'],
        //         fieldThree:[],
        //     }))
        // }
        // if(e == '七、资源与环境'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo:['（一）水污染控制技术','（二）大气污染控制技术','（三）固体废弃物的处理与综合利用技术','（四）环境监测技术0','（五）生态环境建设与保护技术','（六）清洁生产与循环经济技术','（七）资源高效开发与综合利用技术'],
        //         fieldThree:[],
        //     }))
        // }
        // if(e == '八、先进制造与自动化'){
        //     this.setState(()=>({
        //         fieldTwoChoose:'请选择',
        //         fieldThreeChoose:'请选择',
        //         disabledStatus1:false,
        //         disabledStatus2:false,
        //         fieldTwo:['（一）工业生产过程控制系统','（二）高性能、智能化仪器仪表','（三）先进制造技术'],
        //         fieldThree:[],
        //     }))
        // }
    }
    fieldChangeTwo(e){
        this.setState({
            fieldTwoChoose:e
        })
        fetchPost(global.constants.getThreeLevel,{oneLevel:this.state.fieldOneChoose,twoLevel:e})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            fieldThreeChoose:'请选择',
                            disabledStatus2:false,
                            fieldThree:res.data,
                        }))
                    }
                }
            )
        // if(e == '（一）软件'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.系统软件','2.支撑软件','3.中间件软件','4.嵌入式软件','5.计算机辅助工程管理软件','6.中文及多语种处理软件','7.图形和图像软件','8.金融信息化软件','9.地理信息系统','10.电子商务软件','11.电子政务软件','12.企业管理软件']
        //     }))
        // }
        // if(e == '（二）微电子技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.集成电路设计技术','2.集成电路产品设计技术','3.集成电路封装技术','4.集成电路测试技术','5.集成电路芯片制造技术','6.集成光电子器件技术']
        //     }))
        // }
        // if(e == '（三）计算机及网络技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.计算机及终端技术','2.各类计算机外围设备技术','3.网络技术','4.空间信息获取及综合应用集成系统','5.面向行业及企业信息化的应用系统','6.传感器网络节点、软件和系统']
        //     }))
        // }
        // if(e == '（四）通信技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.光传输技术','2.小型接入设备技术','3.无线接入技术','4.移动通信系统的配套技术','5.软交换和VoIP系统','6.业务运营支撑管理系统','7.电信网络增值业务应用系统']
        //     }))
        // }
        // if(e == '（五）广播电视技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.演播室设备技术','2.交互信息处理系统','3.信息保护系统','4.数字地面电视技术','5.地面无线数字广播电视技术','6.专业音视频信息处理系统','7.光发射、接收技术','8.电台、电视台自动化技术','9.网络运营综合管理系统 ','10.IPTV技术','11.高端个人媒体信息服务平台']
        //     }))
        // }
        // if(e == '（六）新型电子元器件'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.半导体发光技术','2.片式和集成无源元件技术','3.片式半导体器件技术','4.中高档机电组件技术']
        //     }))
        // }
        // if(e == '（七）信息安全技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.安全测评类','2.安全管理类','3.安全应用类','4.安全基础类','5.网络安全类','6.专用安全类']
        //     }))
        // }
        // if(e == '（八）智能交通技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.先进的交通管理和控制技术','2.交通基础信息采集、处理设备及相关软件技术','3.先进的公共交通管理设备和系统技术','4.车载电子设备和系统技术']
        //     }))
        // }
        // if(e == '（一）医药生物技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.新型疫苗','2.基因工程药物','3.重大疾病的基因治疗','4.单克隆抗体系列产品与检测试剂','5.蛋白质/多肽/核酸类药物','6.生物芯片','7.生物技术加工天然药物','8.生物分离、装置、试剂及相关检测试剂','9.新生物技术']
        //     }))
        // }
        // if(e == '（二）中药、天然药物'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.创新药物','2.中药新品种的开发','3.中药资源可持续利用']
        //     }))
        // }
        // if(e == '（三）化学药'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.创新药物','2.心脑血管疾病治疗药物','3.抗肿瘤药物','4.抗感染药物(包括抗细菌、抗真菌、抗原虫药等)',' 5.老年病治疗药物','6.精神神经系统药物','7.计划生育药物','8.重大传染病治疗药物','9.治疗代谢综合症的药物','10.罕见病用药及诊断用药','11.手性药物和重大工艺创新的药物及药物中间体']
        //     }))
        // }
        // if(e == '（四）新剂型及制剂技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.缓、控、速释制剂技术——固体、液体及复方','2.靶向给药系统','3.给药新技术及药物新剂型','4.制剂新辅料']
        //     }))
        // }
        // if(e == '（五）医疗仪器技术、设备与医学专用软件'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.医学影像技术','2.治疗、急救及康复技术','3.电生理检测、监护技术','4.医学检验技术','5.医学专用网络环境下的软件']
        //     }))
        // }
        // if(e == '（六）轻工和化工生物技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.生物催化技术','2.微生物发酵新技术','3.新型、高效工业酶制剂','4.天然产物有效成份的分离提取技术','5.生物反应及分离技术','6.功能性食品及生物技术在食品安全领域的应用']
        //     }))
        // }
        // if(e == '（七）现代农业技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.农林植物优良新品种与优质高效安全生产技术','2.畜禽水产优良新品种与健康养殖技术','3.重大农林植物灾害与动物疫病防控技术','4.农产品精深加工与现代储运','5.现代农业装备与信息化技术','6.水资源可持续利用与节水农业','7.农业生物技术']
        //     }))
        // }
        // if(e == '（一)金属材料'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.铝、镁、钛轻合金材料深加工技术','2.高性能金属材料及特殊合金材料生产技术','3.超细及纳米粉体及粉末冶金新材料工艺技术','4.低 成本、高性能金属复合材料加工成型技术','5.电子元器件用金属功能材料制造技术','6.半导体材料生产技术','7.低成本超导材料实用化技术','8.特殊功能有色金属材料及应用技术','9.高性能稀土功能材料及其应用技术','10.金属及非金属材料先进制备、加工和成型技术']
        //     }))
        // }
        // if(e == '（二）无机非金属材料'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.高性能结构陶瓷强化增韧技术','2.高性能功能陶瓷制造技术','3.人工晶体生长技术','4.功能玻璃制造技术','5.节能与环保用新型无机非金属材料制造技术']
        //     }))
        // }
        // if(e == '（三）高分子材料'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.高性能高分子结构材料的制备技术','2.新型高分子功能材料的制备及应用技术','3.高分子材料的低成本、高性能化技术','4.新型橡胶的合成技术及橡胶新材料','5.新型纤维材料','6.环境友好型高分子材料的制备技术及高分子材料的循环再利用技术','7.高分子材料的加工应用技术']
        //     }))
        // }
        // if(e == '（四）生物医用材料'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.介入治疗器具材料','2.心血管外科用新型生物材料及产品','3.骨科内置物','4.口腔材料','5.组织工程用材料及产品','6.载体材料、控释系统用材料','7.专用手术器械及材料']
        //     }))
        // }
        // if(e == '（五）精细化学品'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.电子化学品','2.新型催化剂技术','3.新型橡塑助剂技术','4.超细功能材料技术','5.功能精细化学品']
        //     }))
        // }
        // if(e == '（一）可再生清洁能源技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.太阳能（1）太阳能热利用技术', '1.太阳能（2）太阳能光伏发电技术','1.太阳能（3）太阳能热发电技术','2.风能（1）1.5MW以上风力发电技术','2.风能（2）风电场配套技术','3.生物质能（1）生物质发电关键技术及发电原料预处理技术','3.生物质能（2）生物质固体燃料致密加工成型技术','3.生物质能（3）生物质固体燃料高效燃烧技术','3.生物质能（4）生物质气化和液化技术','3.生物质能（5）非粮生物液体燃料生产技术','3.生物质能（6）大中型生物质能利用技术','4.地热能利用']
        //     }))
        // }if(e == '（二）核能及氢能'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.核能技术','2.氢能技术']
        //     }))
        // }if(e == '（三）新型高效能量转换与储存技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.新型动力电池（组）、高性能电池（组）','2.燃料电池、热电转换技术']
        //     }))
        // }if(e == '（四）高效节能技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.钢铁企业低热值煤气发电技术','2.蓄热式燃烧技术','3.低温余热发电技术','4.废弃燃气发电技术','5.蒸汽余压、余热、余能回收利用技术','6.输配电系统优化技术','7.高泵热泵技术','8.蓄冷蓄热技术','9.能源系 统管理、优化与控制技术','10.节能监测技术','11.节能量检测与节能效果确认技术']
        //     }))
        // }
        // if(e == '（一）水污染控制技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.城镇污水处理技术','2.工业废水处理技术','3.城市和工业节水和废水资源化技术','4.面源水污染的控制技术','5.雨水、海水、苦咸水利用技术','6.饮用水安全保障技术']
        //     }))
        // }
        // if(e == '（二）大气污染控制技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.煤燃烧污染防治技术','2.机动车排放控制技术','3.工业可挥发性有机污染物防治技术','4.局部环境空气质量提高与污染防治技术','5.其他重污染行业空气污染防治技术']
        //     }))
        // }
        // if(e == '（三）固体废弃物的处理与综合利用技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.危险固体废弃 物的处置技术','2.工业固体废弃物的资源综合利用技术','3.有机固体废物的处理和资源化技术']
        //     }))
        // }
        // if(e == '（四）环境监测技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.在线连续自动监测技术','2.应急监测技术','3.生态环境监测技术']
        //     }))
        // }
        // if(e == '（五）生态环境建设与保护技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:true,
        //         fieldThree:[]
        //     }))
        // }
        // if(e == '（六）清洁生产与循环经济技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.重点行业污染减排和“零排放”关键技术','2.污水和固体废物回收利用技术','3.清洁生产关键技术','4.绿色制造关键技术']
        //     }))
        // }
        // if(e == '（七）资源高效开发与综合利用技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:[ '1.提高资源回收利用率的采矿、选矿技术','2.共、伴生矿产的分选提取技术','3.极低品位资源和尾矿资源综合利用技术']
        //     }))
        // }
        // if(e == '（一）工业生产过程控制系统'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.现场总线及工业以太网技术','2.可编程 序控制器（PLC）','3.基于PC的控制系统','4.新一代的工业控制计算机' ]
        //     }))
        // }
        // if(e == '（二）高性能、智能化仪器仪表'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.新型自动化仪表技术','2.面向行业的传感器技术','3.新型传感器技术','4.科学分析仪器、检测仪器技术','5.精确制造中的测控仪器技术']
        //     }))
        // }
        // if(e == '（三）先进制造技术'){
        //     this.setState(()=>({
        //         fieldThreeChoose:'请选择',
        //         disabledStatus2:false,
        //         fieldThree:['1.先进制造系统及数控加工技术','2.机器人技术','3.激光加工技术','4.电力电子技术','5.纺织及轻工行业专用设备技术']
        //     }))
        // }
    }
    fieldChangeThree(e){
        this.setState({
            fieldThreeChoose:e,
        })
    }
    memberChange(e){
        this.setState({
            member:e
        })
    }
    researcherChange(e){
        this.setState({
            researcher:e
        })
    }
    incomeChange(e){
        this.setState({
            income:e
        })
    }
    allIncomeChange(e){
        this.setState({
            allIncome:e
        })
    }
    registerAreaChange(e){
        this.setState({
            registerArea:e
        })
    }
    companyNameChangeNew(e){
        this.setState({
            newCompanyName:e
        })
    }
    registerTimeChangeNew=(value,dateString)=>{
        this.setState({
            newRegisterTime:dateString
        })
    }
    declareTimeChangeNew=(value,dateString)=>{
        this.setState({
            newDeclareTime:dateString
        })
    }
    areaChangeNew(e){
        this.setState({
            newArea:e
        })
    }
    fieldChangeNew(e){
        this.setState({
            newField:e
        })
    }
    editField(){
        this.setState({
            edit_field_visible:true
        })
    }
    submitField(){
        if(this.state.fieldTwoChoose === "请选择" || this.state.fieldTwoChoose === null ){
            this.setState({
                newField:this.state.fieldOneChoose +'-'+ this.state.fieldThreeChoose,
                edit_field_visible:false,
            })
        }else{
            if(this.state.fieldThreeChoose === "请选择" || this.state.fieldThreeChoose === null ){
                this.setState({
                    newField:this.state.fieldOneChoose +'-'+ this.state.fieldTwoChoose,
                    edit_field_visible:false,
                })
            }else{
                this.setState({
                    newField:this.state.fieldOneChoose + '-' + this.state.fieldTwoChoose + '-' + this.state.fieldThreeChoose,
                    edit_field_visible:false,
                })
            }

        }

    }
    memberChangeNew(e){
        this.setState({
            newMember:e
        })
    }
    researcherChangeNew(e){
        this.setState({
            newResearcher:e
        })
    }
    incomeChangeNew(e){
        this.setState({
            newIncome:e
        })
    }
    allIncomeChangeNew(e){
        this.setState({
            newAllIncome:e
        })
    }
    registerAreaChangeNew(e){
        this.setState({
            newRegisterArea:e
        })
    }

}
export default CompanyList;